import { initialState } from '../schema';

// sets next route location
export const reduceRemoveNextRouteLocation = (state) => ({
  ...state,
  nextRouteLocation: initialState.nextRouteLocation,
});
